import { http } from "./httpServices";
import api from "../apiConfig";

const url = api.global + "/calendar";

function calendarUrl(id) {
  return `${url}/${encodeURIComponent(id)}`;
}

export function getAllCalendars() {
  return http.get(url);
}

export async function getPublicCalendars() {
  const response = await getAllCalendars();
  const data = Array.isArray(response.data) ? response.data : [];
  return {
    ...response,
    data: data
      .filter((item) => item.status !== "draft")
      .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)),
  };
}

export function getCalendar(calendarId) {
  return http.get(calendarUrl(calendarId));
}

export function saveCalendar(calendar) {
  return http.post(url, calendar, {
    headers: { "Content-Type": "application/json" },
  });
}

export function updateCalendar(calendar) {
  return http.put(calendarUrl(calendar._id), calendar, {
    headers: { "Content-Type": "application/json" },
  });
}

export function deleteCalendar(calendarId) {
  return http.delete(calendarUrl(calendarId));
}

export function normalizeCalendarForDisplay(calendars) {
  return calendars.map((item, index) => ({
    id: item.sortOrder ?? index + 1,
    _id: item._id,
    year: item.year,
    info: item.info || "Academic calendar",
    term: (item.terms || []).map((term, termIndex) => ({
      id: term.id ?? termIndex + 1,
      sem: term.sem,
      calendar: (term.calendar || []).map((entry, entryIndex) => ({
        id: entry.id ?? entryIndex + 1,
        opp: entry.opp,
        beginDate: entry.beginDate,
        endDate: entry.endDate,
        duration: entry.duration ?? "",
      })),
    })),
  }));
}
